import React, { Component, Fragment, useEffect } from 'react';
import styled, { withTheme } from 'styled-components';
import {
  MemoryRouter,
  Redirect,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import {
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';
import Footer from './components/Footer';

import Theme from './routes/Theme';
import TimelessTheme from './routes/TimelessTheme';
import Search from './routes/Search';
import Reports from './routes/Reports';
import Archive from './routes/Archive';
import Collection from './routes/Collection';
import Timeless from './routes/Timeless';
import Category from './routes/Category'
import Glossary from './routes/Glossary';
import GlossaryTerm from './routes/GlossaryTerm';
import Manuals from "./routes/Manuals";
import Profile from './routes/Profile';
import PageLoadingOverlay from './components/PageLoadingOverlay';
import PageLoadingOverlayStore from './flux/PageLoadingOverlayStore';
import JwtStore from './flux/JwtStore';
import UserStore from './flux/UserStore';
import HttpErrorStore from './flux/HttpErrorStore';
import ModalFullscreen from './components/ModalFullscreen';
import ProductFocusGroups from "./routes/ProductFocusGroups";
import ProductFocuses from "./routes/ProductFocuses";
import TabBar from './components/TabBar';
import RenderOnMobile from './components/responsive/RenderOnMobile';
import RenderOnTablet from './components/responsive/RenderOnTablet';
import Seasonal from './routes/Seasonal';
import ModalFullscreenStore from './flux/ModalFullscreenStore';
import RouterStore from "./flux/RouterStore";
import MobileManuals from "./routes/MobileManuals";
import ModalFullscreenActions from "./flux/ModalFullscreenActions";
import MobileNews from "./routes/MobileNews";
import FeedbackHelpContainer from './components/FeedbackHelpContainer';
import Homepage from "./routes/Homepage";

function setNamedUser(window, namedUserId, tagGroups) {
  const data = {
    namedUserId,
    ...tagGroups,
  };

  if (window.ReactNativeWebView !== undefined) {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      name: 'set-named-user',
      data,
    }))
  } else if (window.frameElement !== null) {
    window.parent.postMessage(JSON.stringify({
      name: 'set-named-user',
      data,
    }))
  } else {
    //
  }
}

function responsaFormRender(props) {
  return (
    <FeedbackHelpContainer>
      <iframe
        title="feedback-help-modal"
        src={props.url}
        frameBorder="0"
        style={{ fontSize: 0 }}
      />
    </FeedbackHelpContainer>
  )
}

class App extends Component {
  state = {
    pageLoadingOverlayVisible: PageLoadingOverlayStore.getState(),
    // We make the language code a state property of the entire application so
    // it gets re-rendered whenever the language changes and its labels
    // updated. Not the best solution but it shouldn't cause any side-effects.
    currentLanguageCode: UserStore.getLanguageCode(),
    hasNews: false,
    modalFullscreen: ModalFullscreenStore.getState(),
  };

  subscriptions = [];

  componentDidMount() {
    setNamedUser(window, JwtStore.getUsername(), {
      regions: JwtStore.getRegions(),
      countries: JwtStore.getCountries(),
      stores: JwtStore.getStores(),
      roles: JwtStore.getRoles(),
    });

    this.subscriptions.push(
      HttpErrorStore.addListener(this.handleHttpErrorStoreChange)
    );

    this.subscriptions.push(
      PageLoadingOverlayStore.addListener(this.handlePageLoadingStoreChange)
    );

    this.subscriptions.push(
      UserStore.addListener(this.handleUserStoreChange)
    );

    this.subscriptions.push(
      ModalFullscreenStore.addListener(this.handleModalFullscreenChange)
    );

    this.subscriptions.push(
      RouterStore.addListener(this.handleRouteChange)
    );
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
    clearAllBodyScrollLocks();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (
    //   prevProps.location !== this.props.location &&
    //   this.state.modalFullscreen.isVisible
    // ) {
    //   console.log('url changed');
    // }
  }

  handleHttpErrorStoreChange = () => {
    const lastError = HttpErrorStore.getState().stack[0];

    if (lastError === undefined) {
      return;
    }

    // inside a setTimeout to prevent "cannot dispatch in the middle of a
    // dispatch" error.
    setTimeout(() => {
      // we redirect to the homepage if there are 404 http errors. a bit
      // generic and maybe too broad but should do for now.
      if (lastError.status === 404) {
        this.props.history.replace('/');
      }
    }, 0);
  }

  handlePageLoadingStoreChange = () => {
    this.setState({
      pageLoadingOverlayVisible: PageLoadingOverlayStore.getState(),
      hasNews: JwtStore.getHasNews()
    });

    window.scrollTo(0, 0);
  };

  handleUserStoreChange = () => {
    if (this.state.currentLanguageCode !== UserStore.getLanguageCode()) {
      // By updating the currentLanguageCode property, the application is
      // re-rendered, updating all the labels. There might be a better way.
      this.setState({ currentLanguageCode: UserStore.getLanguageCode() });
    }
  };

  handleModalFullscreenChange = () => {
    const modalFullscreen = ModalFullscreenStore.getState();

    this.setState({ modalFullscreen });

    // if (modalFullscreen.isVisible === true) {
    //   disableBodyScroll(document.documentElement);
    // } else {
    //   enableBodyScroll(document.documentElement);
    // }
  };

  handleRouteChange = () => {
    const path = RouterStore.getState().main;
    if(path !== null) {
      this.props.history.push(path);
    }
  }

  render() {
    return (
      <>
        <MemoryRouter>
          <Route exact path="/logout" render={() => {
            // if the memory router navigates to /logout, we make the main
            // router navigate to /logout.
            this.props.history.push('logout');
          }} />

          {this.state.modalFullscreen.properties.routeUri !== undefined && (
            <Route key={this.state.modalFullscreen.properties.routeUri} path="/" component={FullscreenModalRedirectToRouteUri} />
          )}

          <ModalFullscreen
            isOpen={this.state.modalFullscreen.isVisible}
            isLoading={this.state.pageLoadingOverlayVisible}
          >
            {this.state.modalFullscreen.name === 'help' ? (
              responsaFormRender(this.state.modalFullscreen.properties)
            ) : this.state.modalFullscreen.name === 'report_problem' ? (
              responsaFormRender(this.state.modalFullscreen.properties)
            ) : this.state.modalFullscreen.name === 'suggestion' ? (
              responsaFormRender(this.state.modalFullscreen.properties)
            ) : this.state.modalFullscreen.name === 'user' ? (
              <Profile {...this.state.modalFullscreen.properties} />
            ) : this.state.modalFullscreen.name === 'glossary' ? (
              <Glossary {...this.state.modalFullscreen.properties} />
            ) : this.state.modalFullscreen.name === 'search' ? (
              <Search {...this.state.modalFullscreen.properties} />
            ) : this.state.modalFullscreen.name === 'news' ? (
              <MobileNews {...this.state.modalFullscreen.properties} />
            ) : null }
          </ModalFullscreen>
        </MemoryRouter>

        <Switch>
          <AppContainer>
            <Container>
              <PageLoadingOverlay visible={this.state.pageLoadingOverlayVisible} />

              <Switch>
                <Route exact path="/(hot-now|to-complete|never-seen)" component={Homepage} />
                <Route exact path="/search"  component={Search} />

                {(JwtStore.canViewReport() || JwtStore.isStoreAssistant() || JwtStore.isOffice()) && (
                  <Route
                    path="/reports/:collectionType/:parentId/:region?/:country?/:store?/:username?"
                    component={Reports}
                  />
                )}

                <Route exact path="/profile"  component={Profile} />

                <Route exact path="/archive"  component={Archive} />

                {this.props.theme.isTablet ? [
                  <Route key={0} exact path="/glossary" component={Glossary}  />,
                  <Route key={1} exact path="/glossary/:id(\d+)" component={GlossaryTerm} />,
                ] : [
                  <Route key={0} exact path="/glossary" component={RedirectToFullscreenModal}  />,
                  <Route key={1} exact path="/glossary/:id(\d+)" component={RedirectToFullscreenModal} />
                ]}

                <Route exact path="/seasonal/:collectionId/themes/:themeId"  component={Theme} />
                <Route path="/seasonal/:collectionId" component={Collection} />

                {this.props.theme.isMobile && (
                  <Route exact path="/seasonal" component={Seasonal} />
                )}

                {this.props.theme.isMobile ? (
                  <Route exact path="/manuals" component={MobileManuals} />
                ): (
                  <Route exact path="/manuals"  component={Manuals} />
                )}

                {this.props.theme.isTablet && (
                  <Redirect exact path="/seasonal" to="/archive" />
                )}

                <Route exact path="/timeless"  component={Timeless} />
                <Route exact path="/timeless/:categoryId"  component={Category} />
                <Route exact path="/timeless/:categoryId/themes/:themeId"  component={TimelessTheme} />

                {JwtStore.isAvailableFeature('product-focus') ? ([
                  <Route key={0} exact path="/product-focuses"  component={ProductFocuses} />,
                  <Route key={1} exact path="/product-focuses/:productFocusId"  component={ProductFocusGroups} />,
                  <Route key={2} exact path="/product-focuses/:productFocusId/group/:groupProductFocusId"  component={ProductFocusGroups} />
                ]) : null}

                {this.props.theme.isTablet ? (
                  <Route exact path="/news" render={props => {
                    props.history.replace('/profile')
                    return null;
                  }} />
                ) : (
                  <Route exact path="/news" component={RedirectToFullscreenModal} />
                )}

                <Redirect to="/hot-now" />
              </Switch>
            </Container>
          </AppContainer>
        </Switch>

        <RenderOnMobile>
          <TabBar />
        </RenderOnMobile>

        <RenderOnTablet>
          <Footer />
        </RenderOnTablet>
      </>
    );
  }
}

export default withTheme(withRouter(App));

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  background-color: ${props => props.theme.primaryBackgroundColor};
`;

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  transform: translateZ(0);
  min-height: 10rem;
`;

function RedirectToFullscreenModal(props) {

  useEffect(() => {
    if (props.match.path === '/news') {
      ModalFullscreenActions.user({ routeUri: '/news' });
    } else if (props.match.path === '/glossary') {
      ModalFullscreenActions.glossary();
    } else if (props.match.path === '/glossary/:id(\\d+)') {
      ModalFullscreenActions.glossary({ routeUri: `/${props.match.params.id}` });
    }

    props.history.replace('/hot-now');
  }, []);

  return null;
}

function FullscreenModalRedirectToRouteUri(props) {
  useEffect(() => {
    props.history.push(
      ModalFullscreenStore.getState().properties.routeUri
    );

    ModalFullscreenActions.clearRouteUri();
  }, []);

  return null;
}
